<template>
  <div class="contents">
    <div class="content_map">
      <MachineTar></MachineTar>
      <div class="tablist_item">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item v-if="this.$store.state.Code === '11'">
            <el-select
              placeholder="请选择区"
              v-model="search.countyCode"
              style="width: 150px"
              clearable
            >
              <el-option
                v-for="(item, index) in countyList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }">
            <el-select
              placeholder="机具类型"
              v-model="search.njType"
              style="width: 150px"
              clearable
            >
              <!-- :multiple="true" -->
              <el-option
                v-for="(item, index) in buyNjList"
                :label="item.catName"
                :value="item.id"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="search.dateTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="作业开始日期"
              end-placeholder="作业结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="content_bottom">
        <div class="content_tar">
          <ul class="top_bar_btm">
            <li class="top_bar">
              <span>减排机具总数（台）</span><span>{{toolList.totalNjNum}}</span>
            </li>
            <li><span>拖拉机数量（台）</span><span>{{toolList.tljNum}}</span></li>
            <li><span>收获机数量（台）</span><span>{{toolList.shjNum}}</span></li>
          </ul>
          <ul class="top_bar_btm">
            <li class="top_bar">
              <span>总的作业面积（亩）</span><span>{{toolList.totalWorkArea}}</span>
            </li>
            <li><span>耕地作业（亩）</span><span>{{toolList.gdWorkArea}}</span></li>
            <li><span>收获作业（亩）</span><span>{{toolList.shWorkArea}}</span></li>
          </ul>
          <ul>
            <li class="top_bar">
              <span>总的行驶里程（公里）</span><span>{{toolList.totalMileage}}</span>
            </li>
            <li><span>道路行驶里程（公里）</span><span>{{toolList.roadMileage}}</span></li>
            <li><span>田间行驶里程（公里）</span><span>{{toolList.workMileage}}</span></li>
          </ul>
          <ul>
             <li class="top_bar">
              <span>总的减排量（克）</span><span>{{toolList.totalEmission}}</span>
            </li>
            <li><span>行驶排放量（克）</span><span>{{toolList.roadEmission}}</span></li>
            <li><span>作业排放量（克）</span><span>{{toolList.workEmission}}</span></li>
          </ul>
        </div>
        <div class="content_bottoms">
          <div class="tabar_item">
            <div
              class="itemsE"
              :class="[{ active: activeNameE == item.name }]"
              v-for="item in itemListData"
              :key="item.id"
              @click="tabItemDataClick(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="content_right">
            <div class="tablist_item-d">
              <div
                class="items"
                :class="[{ active: activeNames == item.name }]"
                v-for="item in itemList"
                :key="item.id"
                @click="tabItemClick(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="area" v-if="echartsShow">
              <div id="timeChart"></div>
            </div>
            <div class="area1" v-show="echartsShow1">
              <div id="timeChart1"></div>
            </div>
            <div class="area2" v-show="echartsShow2">
              <div id="timeChart2"></div>
            </div>
            <div class="area3" v-show="echartsShow3">
              <div id="timeChart3"></div>
            </div>
            <div class="area4" v-show="echartsShow4">
              <div id="timeChart4"></div>
            </div>
            <div class="area5" v-show="echartsShow5">
              <div id="timeChart5"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isloading">
        <div class="el-loading-spinner">
          <i class="el-icon-loading"></i>
          <p class="el-loading-text">拼命加载中</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MachineTar from "./MachineTar.vue";
import Http from "../../Serves/net-http.js";
import Api from "../../Serves/net-api.js";
export default {
  components: {
    MachineTar
  },
  data() {
    return {
      search: {
        countyCode: "",
        njType: "",
        dateTime: [this.getFirstDayOfYear(new Date()), this.getNowFormatDates()]
      },
      countyList: [],
      buyNjList: [
        {
          id: 46,
          catName: "拖拉机"
        },
        {
          id: 47,
          catName: "收获机"
        }
      ],
      tableData: [],
      total: 1,
      itemList: [
        {
          id: 1,
          name: "按日显示"
        },
        {
          id: 2,
          name: "按周显示"
        },
        {
          id: 3,
          name: "按月显示"
        }
      ],
      activeNames: "按日显示",
      itemListData: [
        {
          id: 1,
          name: "减排机具总量"
        },
        {
          id: 2,
          name: "作业面积"
        },
        {
          id: 3,
          name: "道路行驶里程"
        },
        {
          id: 4,
          name: "行驶减排量"
        },
        {
          id: 5,
          name: "田间作业里程"
        },
        {
          id: 6,
          name: "作业减排量"
        }
      ],
      activeNameE: "减排机具总量",
      groupType: 1,
      njMyCharts: "",
      selectAreaNjNumsLists: [],
      dateFormats: "YYYY-MM-DD",
      dateString: [],
      njMaxNum: "",
      loading: false,
      nodata: false,
      echartsShow: true,
      echartsShow1: false,
      echartsShow2: false,
      echartsShow3: false,
      echartsShow4: false,
      echartsShow5: false,
      isloading: false,
      njMyCharts1: "",
      njMyCharts2: "",
      njMyCharts3: "",
      njMyCharts4: "",
      njMyCharts5: "",
      activeId: 1,
      toolList: [],
      activeType: 1
    };
  },
  mounted() {
    if (this.$store.state.Code === '11') {
      this.getCountyList(this.$store.state.info.provCode);
    }
    this.inits();
    // 统计数接口
    this.getSelectAreaNjNums();
    this.findEmissionReductionByTime(this.activeType)
    setTimeout(() => {
      this.$nextTick(() => {
        // this.chart();
        this.inits();
      });
    });
  },
  methods: {
    inits() {
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.njMyCharts.resize();
          this.njMyCharts1.resize();
          this.njMyCharts2.resize();
        });
      });
    },
    getCountyList(value) {
      var url = Http.test + "/area/getCountyOfProvinceForMunicipality";
      Api.doPost(url, { provCode: value }, false, res => {
        this.countyList = res.result;
      });
    },
    findEmissionReductionByTime (id) {
      var parmse = {
        provCode: this.$store.state.info.provCode,
        // beginDate:
        //   this.search.dateTime[0].split("-")[0] +
        //   this.search.dateTime[0].split("-")[1] +
        //   this.search.dateTime[0].split("-")[2],
        // endDate:
        //   this.search.dateTime[1].split("-")[0] +
        //   this.search.dateTime[1].split("-")[1] +
        //   this.search.dateTime[1].split("-")[2],
        dateStart:
          this.search.dateTime[0].split("-")[0] +
          this.search.dateTime[0].split("-")[1] +
          this.search.dateTime[0].split("-")[2],
        dateEnd:
          this.search.dateTime[1].split("-")[0] +
          this.search.dateTime[1].split("-")[1] +
          this.search.dateTime[1].split("-")[2],
        groupType: this.groupType,
        countyCode:
          this.search.countyCode,
          type: id,
        njType: this.search.njType,
        
      };
      var url = Http.test + "/emissionReduction/findEmissionReductionByTime";
      Api.doPost(
        url,
        parmse,
        false,
        res => {
          if (this.activeNameE === '减排机具总量'){
            // 机具总量
            this.$nextTick(() => {
              this.chart(res.result.njNum)
            })
          } else if (this.activeNameE === '作业面积'){
            // 作业面积
            this.$nextTick(() => {
              this.chart1(res.result.workArea)
            });
          } else if (this.activeNameE === '道路行驶里程'){
            // 道路行驶里程
            this.$nextTick(() => {
              this.chart2(res.result.roadMileageList)
            });
          } else if (this.activeNameE === '行驶减排量'){
            // 行使减排量
            this.$nextTick(() => {
              this.chart3(res.result.roadEmissionList)
            });
          } else if (this.activeNameE === '田间作业里程'){
            // 田间作业里程
            this.$nextTick(() => {
              this.chart4(res.result.workMileageList)
            });
          } else if (this.activeNameE === '作业减排量'){
            // 作业减排量
            this.$nextTick(() => {
              this.chart5(res.result.workEmissionList)
            });
          } else {
            // 机具总量
            this.$nextTick(() => {
              this.chart(res.result.njNum)
            })
          }
        },
        doError => {
          console.log(doError);
        }
      );
    },
    chart(data) {
      var resultarrs = data.map(item => {
        return item.dateStr;
      });
      var imeiNumarrs = data.map(item => {
        return item.imeiNum;
      });
      this.njMyCharts = this.$echarts.init(
        document.getElementById("timeChart")
      );
      this.njMyCharts.setOption({
        tooltip: {
          show: true,
          axisPointer: {
            type: "shadow"
          },
          trigger: 'axis',
          formatter: "{b} <br/>减排机具总量 : {c}台"
          // axisPointer: { // 坐标轴指示器，坐标轴触发有效
          //   type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          // },
          // formatter: "{b} <br/>减排机具总量 : {c}台"
          // trigger: "axis",
          // axisPointer: {
          //   type: "cross"
          // }
        },
        dataZoom: [
          //X轴滑动条
          {
            type: "slider", //滑动条
            show: this.groupType === 1 || this.groupType === 2 ? true : false, //开启
            // show: true, //开启
            xAxisIndex: [0],
            left: "2%", //滑动条位置
            bottom: "2%",
            start: 0, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 70 : 100, //初始化时，滑动条宽度结束标度
            textStyle: {
              color: "#ffffff"
            }
          },
          //X轴内置滑动
          {
            show: this.groupType === 1 ? true : false, //开启
            type: "inside", //内置滑动，随鼠标滚轮展示
            xAxisIndex: [0],
            start: 1, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 70 : 100, //初始化时，滑动条宽度结束标度
          }
        ],
        legend: {
          top: "3%",
          data: ["tractor", "harvester"],
          textStyle: {
            color: "#ffffff",
            padding: [3, 0, 0, 0]
          }
        },
        grid: {
          top: "15%",
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: resultarrs,
          // data: [
          //   "Mon",
          //   "Tue",
          //   "Wed",
          //   "Thu",
          //   "Fri",
          //   "Sat",
          //   "Sun",
          //   "Mon",
          //   "Tue",
          //   "Wed",
          //   "Thu",
          //   "Fri"
          // ],
          axisLabel: {
            color: "#fff",
            rotate: 45
          },
          axisLine: {
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            color: "#fff"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              width: 0.2,
              type: "dashed",
              color: "#e9e9e9"
            }
          }
        },
        series: [
          {
            name: '减排机具总量',
            type: "bar",
            stack: "total",
            barWidth: 15,
            label: {
              // show: true
            },
            data: imeiNumarrs
            // data: [320, 302, 301, 334, 390, 330, 320, 320, 302, 301, 334, 390]
          },
          // {
          //   name: "harvester",
          //   type: "bar",
          //   stack: "total",
          //   barWidth: 30,
          //   label: {
          //     // show: true
          //   },
          //   data: [120, 132, 101, 134, 90, 230, 210, 320, 302, 301, 334, 390]
          // }
        ]
      });
    },
    chart1(data) {
      var resultarrs = data.map(item => {
        return item.dateStr;
      });
      var areaarrs = data.map(item => {
        return item.area;
      });
      this.njMyCharts1 = this.$echarts.init(
        document.getElementById("timeChart1")
      );
      this.njMyCharts1.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line"
          },
          formatter: "{b} <br/>作业面积 : {c}亩"
        },
        dataZoom: [
          //X轴滑动条
          {
            type: "slider", //滑动条
            show: this.groupType === 1 || this.groupType === 2 ? true : false, //开启
            xAxisIndex: [0],
            left: "2%", //滑动条位置
            bottom: "2%",
            start: 0, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
            textStyle: {
              color: "#ffffff"
            }
          },
          //X轴内置滑动
          {
            type: "inside", //内置滑动，随鼠标滚轮展示
            xAxisIndex: [0],
            start: 1, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
          }
        ],
        xAxis: {
          type: "category",
          // boundaryGap: false,
          // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          data: resultarrs,
          axisLabel: {
            color: "#fff",
            rotate: 45
          },
          axisLine: {
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          }
        },
        grid: {
          top: "15%",
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            color: "#fff"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              width: 0.2,
              type: "dashed",
              color: "#e9e9e9"
            }
          }
        },
        series: [
          {
            name: '作业面积',
            data: areaarrs,
            // data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,
            areaStyle: {}
          }
        ]
      });
    },
    chart2(data) {
      var resultarrs = data.map(item => {
        return item.dateStr;
      });
      var roadMileagearrs = data.map(item => {
        return item.roadMileage;
      });
      this.njMyCharts2 = this.$echarts.init(
        document.getElementById("timeChart2")
      );
      this.njMyCharts2.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line"
          },
          formatter: "{b} <br/>道路行驶里程 : {c}公里"
        },
        dataZoom: [
          //X轴滑动条
          {
            type: "slider", //滑动条
            show: this.groupType === 1 || this.groupType === 2 ? true : false, //开启
            xAxisIndex: [0],
            left: "2%", //滑动条位置
            bottom: "2%",
            start: 0, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
            textStyle: {
              color: "#ffffff"
            }
          },
          //X轴内置滑动
          {
            type: "inside", //内置滑动，随鼠标滚轮展示
            xAxisIndex: [0],
            start: 1, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
          }
        ],
        xAxis: {
          type: "category",
          // boundaryGap: false,
          // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          data: resultarrs,
          axisLabel: {
            color: "#fff",
            rotate: 45
          },
          axisLine: {
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          }
        },
        grid: {
          top: "15%",
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            color: "#fff"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              width: 0.2,
              type: "dashed",
              color: "#e9e9e9"
            }
          }
        },
        series: [
          {
            name: '道路行驶里程',
            data: roadMileagearrs,
            // data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line"
          }
        ]
      });
    },
    chart3(data) {
      var resultarrs = data.map(item => {
        return item.dateStr;
      });
      var roadEmissionarrs = data.map(item => {
        return item.roadEmission;
      });
      this.njMyCharts3 = this.$echarts.init(
        document.getElementById("timeChart3")
      );
      this.njMyCharts3.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line"
          },
          formatter: "{b} <br/>行使减排量 : {c}克"
        },
        dataZoom: [
          //X轴滑动条
          {
            type: "slider", //滑动条
            show: this.groupType === 1 || this.groupType === 2 ? true : false, //开启
            xAxisIndex: [0],
            left: "2%", //滑动条位置
            bottom: "2%",
            start: 0, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
            textStyle: {
              color: "#ffffff"
            }
          },
          //X轴内置滑动
          {
            type: "inside", //内置滑动，随鼠标滚轮展示
            xAxisIndex: [0],
            start: 1, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
          }
        ],
        xAxis: {
          type: "category",
          // boundaryGap: false,
          // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          data: resultarrs,
          axisLabel: {
            color: "#fff",
            rotate: 45
          },
          axisLine: {
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          }
        },
        grid: {
          top: "15%",
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            color: "#fff"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              width: 0.2,
              type: "dashed",
              color: "#e9e9e9"
            }
          }
        },
        series: [
          {
            name: '行驶减排量',
            data: roadEmissionarrs,
            // data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line"
          }
        ]
      });
    },
    chart4(data) {
      var resultarrs = data.map(item => {
        return item.dateStr;
      });
      var workMileagearrs = data.map(item => {
        return item.workMileage;
      });
      this.njMyCharts4 = this.$echarts.init(
        document.getElementById("timeChart4")
      );
      this.njMyCharts4.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line"
          },
          formatter: "{b} <br/>田间作业里程 : {c}公里"
        },
        dataZoom: [
          //X轴滑动条
          {
            type: "slider", //滑动条
            show: this.groupType === 1 || this.groupType === 2 ? true : false, //开启
            xAxisIndex: [0],
            left: "2%", //滑动条位置
            bottom: "2%",
            start: 0, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
            textStyle: {
              color: "#ffffff"
            }
          },
          //X轴内置滑动
          {
            type: "inside", //内置滑动，随鼠标滚轮展示
            xAxisIndex: [0],
            start: 1, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
          }
        ],
        xAxis: {
          type: "category",
          // boundaryGap: false,
          // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          data: resultarrs,
          axisLabel: {
            color: "#fff",
            rotate: 45
          },
          axisLine: {
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          }
        },
        grid: {
          top: "15%",
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            color: "#fff"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              width: 0.2,
              type: "dashed",
              color: "#e9e9e9"
            }
          }
        },
        series: [
          {
            name: '田间作业里程',
            data: workMileagearrs,
            // data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line"
          }
        ]
      });
    },
    chart5(data) {
      var resultarrs = data.map(item => {
        return item.dateStr;
      });
      var workEmissionarrs = data.map(item => {
        return item.workEmission;
      });
      this.njMyCharts5 = this.$echarts.init(
        document.getElementById("timeChart5")
      );
      this.njMyCharts5.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line"
          },
          formatter: "{b} <br/>作业减排量 : {c}克"
        },
        dataZoom: [
          //X轴滑动条
          {
            type: "slider", //滑动条
            show: this.groupType === 1 || this.groupType === 2 ? true : false, //开启
            xAxisIndex: [0],
            left: "2%", //滑动条位置
            bottom: "2%",
            start: 0, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
            textStyle: {
              color: "#ffffff"
            }
          },
          //X轴内置滑动
          {
            type: "inside", //内置滑动，随鼠标滚轮展示
            xAxisIndex: [0],
            start: 1, //初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 10 : this.groupType === 2 ? 60 : 100, //初始化时，滑动条宽度结束标度
          }
        ],
        xAxis: {
          type: "category",
          // boundaryGap: false,
          // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          data: resultarrs,
          axisLabel: {
            color: "#fff",
            rotate: 45
          },
          axisLine: {
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          }
        },
        grid: {
          top: "15%",
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            color: "#fff"
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#011e98"
            },
            width: 5
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              width: 0.2,
              type: "dashed",
              color: "#e9e9e9"
            }
          }
        },
        series: [
          {
            name: '作业减排量',
            data: workEmissionarrs,
            // data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line"
          }
        ]
      });
    },
    // 表格统计数据展示
    getSelectAreaNjNums() {
      var parmse = {
        cityCode: '',
        dateStart:
          this.search.dateTime !== null && this.search.dateTime !== ""
            ? this.search.dateTime[0].split("-")[0] +
              this.search.dateTime[0].split("-")[1] +
              this.search.dateTime[0].split("-")[2]
            : "",
        dateEnd:
          this.search.dateTime !== null &&  this.search.dateTime !== ""
            ? this.search.dateTime[1].split("-")[0] +
              this.search.dateTime[1].split("-")[1] +
              this.search.dateTime[1].split("-")[2]
            : "",
        countyCode: this.search.countyCode,
        townCode: "",
        njType: this.search.njType
        // countyCodes:
        //   this.search.countyCode !== "" ? this.search.countyCode.join(",") : "",
        // machineIds:
        //   this.search.njType !== "" ? this.search.njType.join(",") : ""
      };
      var url = Http.test + "/homePageStatis/statisticsScreenERDeviceNum";
      Api.doPost(url, parmse, false, res => {
        this.$nextTick(() => {
          this.toolList = res.result;
        })
      });
    },
    tabItemDataClick(item) {
      this.activeNameE = item.name;
      this.activeType = item.id
      this.findEmissionReductionByTime(item.id)
      if (item.id === 1) {
        this.echartsShow = true;
        this.echartsShow1 = false;
        this.echartsShow2 = false;
        this.echartsShow3 = false;
        this.echartsShow4 = false;
        this.echartsShow5 = false;
        this.njMyCharts1.dispose();
        this.njMyCharts2.dispose();
        this.njMyCharts3.dispose();
        this.njMyCharts4.dispose();
        this.njMyCharts5.dispose();
      } else if (item.id === 2) {
        this.echartsShow1 = true;
        this.echartsShow = false;
        this.echartsShow2 = false;
        this.echartsShow3 = false;
        this.echartsShow4 = false;
        this.echartsShow5 = false;
        this.njMyCharts.dispose();
        this.njMyCharts2.dispose();
        this.njMyCharts3.dispose();
        this.njMyCharts4.dispose();
        this.njMyCharts5.dispose();
      } else if (item.id === 3) {
        this.echartsShow2 = true;
        this.echartsShow = false;
        this.echartsShow1 = false;
        this.echartsShow3 = false;
        this.echartsShow4 = false;
        this.echartsShow5 = false;
        this.njMyCharts.dispose();
        this.njMyCharts1.dispose();
        this.njMyCharts3.dispose();
        this.njMyCharts4.dispose();
        this.njMyCharts5.dispose();
      } else if (item.id === 4) {
        this.echartsShow3 = true;
        this.echartsShow = false;
        this.echartsShow1 = false;
        this.echartsShow2 = false;
        this.echartsShow4 = false;
        this.echartsShow5 = false;
        this.njMyCharts.dispose();
        this.njMyCharts1.dispose();
        this.njMyCharts2.dispose();
        this.njMyCharts4.dispose();
        this.njMyCharts5.dispose();
      } else if (item.id === 5) {
        this.echartsShow4 = true;
        this.echartsShow = false;
        this.echartsShow1 = false;
        this.echartsShow2 = false;
        this.echartsShow3 = false;
        this.echartsShow5 = false;
        this.njMyCharts.dispose();
        this.njMyCharts1.dispose();
        this.njMyCharts2.dispose();
        this.njMyCharts3.dispose();
        this.njMyCharts5.dispose();
      } else if (item.id === 6) {
        this.echartsShow5 = true;
        this.echartsShow = false;
        this.echartsShow1 = false;
        this.echartsShow2 = false;
        this.echartsShow3 = false;
        this.echartsShow4 = false;
        this.njMyCharts.dispose();
        this.njMyCharts1.dispose();
        this.njMyCharts2.dispose();
        this.njMyCharts3.dispose();
        this.njMyCharts4.dispose();
      }
    },
    tabItemClick(item) {
      this.activeNames = item.name;
      this.groupType = item.id;
      this.findEmissionReductionByTime(this.activeType)
      // this.getSelectAreaNjRightNums();
    },
    handleSearch() {
      this.getSelectAreaNjNums();
      this.findEmissionReductionByTime(this.activeType)
      // 图表接口
    },
    timeFormat(date) {
      if (!date || typeof date === "string") {
        this.error("参数异常，请检查...");
      }
      var y = date.getFullYear() - 1; // 年
      // this.yearValue = y
      var m = date.getMonth() + 1; // 月
      var d = date.getDate(); // 日
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 1 && d <= 9) {
        d = "0" + d;
      }
      return y + "-" + m + "-" + d;
    },
    // 获取今年第一个月
    getFirstDayOfYear(date) {
      date.setDate(1);
      date.setMonth(0);
      return this.timeFormat(date);
    },
    // 获取今年当前月
    getNowFormatDates() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
  }
};
</script>
<style scoped lang="less">
.contents {
  width: 100%;
  // height: 100%;
}
.tablist_item {
  width: 100%;
  margin: 0 auto;
}

/deep/ input.el-input__inner,
.el-cascader__dropdown {
  background-color: #0b1680 !important;
  border: 1px solid #1643a2 !important;
}
/deep/ .tablist_item .el-range-editor.el-input__inner {
  background-color: #0b1680 !important;
  border: 1px solid #1643a2 !important;
}

/deep/ .tablist_item .el-date-editor .el-range-input {
  background-color: #0b1680 !important;
}

.content_map {
  width: 98%;
  margin: 0 auto;
}
.tabar_item {
  display: flex;
  margin-bottom: 10px;
  margin-top: 10px;
}
.items {
  height: 2.3vw;
  padding: 0 1vw;
  background-color: #0b1680;
  color: #ffffff;

  font-size: 0.8vw;
  text-align: center;
  line-height: 2.3vw;
  margin-right: 10px;
  border-radius: 0.2vw;
  cursor: pointer;
}
.items.active {
  height: 2.3vw;
  background-color: #f4f4f4;
  color: #000;
  font-size: 0.8vw;
  text-align: center;
  line-height: 2.3vw;
  border-radius: 0.2vw;
}

/* 新加 */
.el-table {
  margin: auto;
  color: #fff;
}
.AreaNjNums {
  width: 100%;
  height: 100%;
}
.content_top {
  position: absolute;
  left: 43%;
  top: 9.2vw;
}
.content_bottom {
  width: 100%;
  margin-top: 1vh;
}
.content_right {
  width: 100%;
  height: 51vh;
  position: relative;
}
.itemsE {
  padding: 0.1vw 1vw;
  color: #ffffff;
  line-height: 1.7vw;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
  background-color: #0b1680;
  border: 1px solid #1643a2;
  color: #ffffff;
  font-size: 0.7vw;
  text-align: center;
  margin-right: 10px;
  border-radius: 1.7vw;
  cursor: pointer;
}
.itemsE.active {
  padding: 0.1vw 1vw;
  color: #ffffff;
  line-height: 1.7vw;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
  font-size: 0.7vw;
  text-align: center;
  margin-right: 10px;
  border-radius: 1.7vw;
  cursor: pointer;
  background-color: #f4f4f4;
  color: #000;
}
.content_bottoms {
  margin-top: 1vh;
}
.tabar_item {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  margin-top: 1vh;
}
.tablist_item-d {
  position: absolute;
  top: 2vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 2vh;
  z-index: 999;
}
.items {
  height: 3vh;
  background-color: #0b1680;
  color: #ffffff;
  font-size: 0.7vw;
  text-align: center;
  margin-right: 10px;
  line-height: 3vh;
  cursor: pointer;
}
.items.active {
  height: 3vh;
  background-color: #f4f4f4;
  color: #000;
  font-size: 0.7vw;
  text-align: center;
  line-height: 3vh;
}
.area,
.area1,
.area2 {
  width: 100%;
  height: 100%;
}
#timeChart {
  width: 100%;
  height: 47vh;
}
#timeChart1 {
  width: 100%;
  height: 47vh;
}
#timeChart2 {
  width: 100%;
  height: 47vh;
}
#timeChart3,#timeChart4,#timeChart5 {
  width: 100%;
  height: 47vh;
}
.el-loading-spinner {
  width: 99% !important;
}

/* 新增样式 */
.content_tar {
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.content_tar ul {
  display: flex;
  width: 49.7%;
}
.content_tar .top_bar_btm li {
  border-bottom: 0;
}
.content_tar ul li {
  display: flex;
  flex-direction: column;
  border: solid 1px #1643a2;
  border-right: 0;
  padding: 0.5vh 0 0.8vh 0.6vw;
  line-height: 1.8rem;
}

.content_tar ul li:nth-child(1) {
  width: 32%;
}
.content_tar ul li:nth-child(2),
.content_tar ul li:nth-child(3) {
  width: 34%;
}
.content_tar ul li:nth-child(3) {
  border-right: solid 1px #1643a2;
}

.content_tar ul .top_bar {
  background: #0b1680;
}
.content_tar ul li span:nth-child(1) {
  color: #358bff;
  font-size: 0.7vw;
}
.content_tar ul li span:nth-child(2) {
  color: #fff;
  font-size: 1.2vw;
}
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/TimeDistribution.vue